import type { ApiModuleEndpoints } from '../types'

export const manufacturingApiEndpoints = {
  outputProductOptions: {
    method: 'GET',
    path: '/manufacturing/output-products/options',
    requiresAuth: true,
  },
  materialProductOptions: {
    method: 'GET',
    path: '/manufacturing/material-products/options',
    requiresAuth: true,
  },
  recipes: { method: 'GET', path: '/manufacturing/recipes', requiresAuth: true },
  createRecipe: { method: 'POST', path: '/manufacturing/recipes', requiresAuth: true },
  recipeDetail: { method: 'GET', path: '/manufacturing/recipes/:id', requiresAuth: true },
  updateRecipe: { method: 'PUT', path: '/manufacturing/recipes/:id', requiresAuth: true },
  activateRecipe: {
    method: 'POST',
    path: '/manufacturing/recipes/:id/activate',
    requiresAuth: true,
  },
  duplicateRecipe: { method: 'POST', path: '/manufacturing/recipes/:id/clone', requiresAuth: true },
  productionOrders: { method: 'GET', path: '/manufacturing/production-orders', requiresAuth: true },
  previewProduction: {
    method: 'POST',
    path: '/manufacturing/production-orders/preview',
    requiresAuth: true,
  },
  createProductionOrder: {
    method: 'POST',
    path: '/manufacturing/production-orders',
    requiresAuth: true,
  },
  commitProductionOrder: {
    method: 'POST',
    path: '/manufacturing/production-orders/commit',
    requiresAuth: true,
  },
  productionOrderDetail: {
    method: 'GET',
    path: '/manufacturing/production-orders/:id',
    requiresAuth: true,
  },
  updateProductionOrder: {
    method: 'PUT',
    path: '/manufacturing/production-orders/:id',
    requiresAuth: true,
  },
  deleteProductionOrder: {
    method: 'DELETE',
    path: '/manufacturing/production-orders/:id',
    requiresAuth: true,
  },
  commitProductionOrderUpdate: {
    method: 'PUT',
    path: '/manufacturing/production-orders/:id/commit',
    requiresAuth: true,
  },
  productionAvailability: {
    method: 'GET',
    path: '/manufacturing/production-orders/:id/availability',
    requiresAuth: true,
  },
  postProductionOrder: {
    method: 'POST',
    path: '/manufacturing/production-orders/:id/post',
    requiresAuth: true,
  },
  cancelProductionOrder: {
    method: 'POST',
    path: '/manufacturing/production-orders/:id/cancel',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
